import { ClassAttributes, HTMLAttributes } from 'react'

type StrongProps = ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>

export function strong({ children, ...props }: StrongProps) {
  return (
    <strong className='font-semibold dark:text-white' {...props}>
      {children}
    </strong>
  )
}
